module.exports = __webpack_public_path__ + "static/media/background_side_menu.560559e4.svg";